// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  dense: "DialSlider__dense",
  fill: "DialSlider__fill",
  frac: "DialSlider__frac",
  fracSlash: "DialSlider__fracSlash",
  input: "DialSlider__input",
  notch: "DialSlider__notch",
  pill: "DialSlider__pill",
  rail: "DialSlider__rail",
  readout: "DialSlider__readout",
  slider: "DialSlider__slider",
  thumb: "DialSlider__thumb",
  tick: "DialSlider__tick",
  tooltip: "DialSlider__tooltip",
  track: "DialSlider__track",
};
